<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" id="vol-1-part-2">
<div class="heading heading-with-title heading-without-image" id="vol-1-part-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Part II</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-part-2-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>Fear not the boastfully strong,</i></p>
<p class="alignment-block-content alignment-block-content-center"><i>but those who pretend to be weak.</i></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>— Matthew Brightwell, 2003</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001part002.vue?9503fb1c